// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-icon-svgIcon-eab66{fill:currentColor;color:#555;height:.48rem;overflow:hidden;width:.48rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"svgIcon": "svg-icon-svgIcon-eab66"
};
export default ___CSS_LOADER_EXPORT___;
